<template>
    <div id="main">
        <link rel="stylesheet" href="/themes/web/assets/css/unit-detail.css?v=3">
        <div class="container">
            <div id="page-header-fixed">
                <div class="">
                    <div id="page-header">
                        <ul class="breadcrumb">
                            <li class="icon">
                                <a @click="$router.push({ name: 'unit', params:{subject_id, unit_id, page: 1} },)">
                                    <img src="/themes/web/assets/images/back-to.svg" alt="">
                                </a>
                            </li>
                            <li class="active">{{unit_name}} - {{lesson_name}}: {{title_lesson}}</li>
                        </ul>
                        <!-- <div>
                            <router-link :to="{path:'/lesson/'+lesson_id+'/assignment'}">
                                <button class="btn btn-lisa-9"><b>{{$t('assignments')}}</b><br/>{{$t('lisa_web_submitted')}}  ({{count_submited}}/{{ assignments.length }})</button>
                            </router-link>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="mark-lesson" v-if="screen != 'list'"></div>
            <div class="card mt-20" style="z-index: 100;overflow: inherit; border-radius: 4px;">
                <div id="close-modal" @click="handleFocusOut"></div>
                <div class="menu-next-item"
                        v-if="show_next_item"
                        >
                    <li @click="nextItem" v-if="(next != '' && next != undefined)">
                        <img v-if="next.type == 'vocabulary'" src="/themes/web/assets/images/lesson/lession-item1.png" style="height:22px; margin-right:5px;">
                        <img v-if="next.type == 'lecture'" src="/themes/web/assets/images/lesson/lession-item1.svg" style="height:22px; margin-right:5px;">
                        <img v-if="next.type == 'practice'" src="/themes/web/assets/images/lesson/lession-item3.png" style="height:22px; margin-right:5px;">
                        <img v-if="next.type == 'assignment'" src="/themes/web/assets/images/icon-assignment-1.png" style="height:22px; margin-right:5px;">
                        {{(next != '' && next != undefined) ? $t(`go_to`)  : ''}}
                        <br>
                        {{(next != '' && next != undefined) ? $t(next.type) : ''}}
                    </li>
                    <!-- <li @click="gotoWave" v-else>
                        {{(next != '' && next != undefined) ? $t(`go_to`) : '123'}}
                        <br>
                        {{(next != '' && next != undefined) ? $t(next.type)  : ''}}
                    </li> -->
                    <li @click="gotoWave"><img src="/themes/web/assets/images/lesson/close1.svg" style="height:22px; margin-right:5px; margin-left: 5px">{{$t('quit_game')}}</li>
                </div>
                <div class="" v-if="screen == 'list'">
                    <div class="wave-lesson">
                        <div class="waves">

                            <template v-for="(item, index) in items">
                                <!--<lesson-detail-item :item="item"/>-->
                                <div class="item-wave-lesson" v-if="item.type == 'vocabulary' && enable_vocab">
                                    <!--<router-link :to="{path: '/lesson/vocabulary/'+item.id}">-->
                                    <div @click="detailLessonOpen(item.id,item.type,item.index)">
                                        <div class="item-wave-lesson-inner">
                                            <div class="rating-crown" v-if="item.star">
                                                <img src="/themes/web/assets/images/icon-crown.svg"
                                                     v-for="(i,a) in item.star" v-bind:key="a">
                                            </div>
                                            <img src="/themes/web/assets/images/vocab-lesson.svg">
                                            <div class="item-wave-lesson-text">
                                                {{$t('vocabulary')}}<i class="lisa-icon-checked" v-if="item.complete == 1"></i><i
                                                    class="lisa-icon-checked-disable"
                                                    v-else></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="item-wave-lesson" v-else-if="item.type == 'lecture'">
                                    <!--<div :to="{path: '/lesson/lecture/'+item.id}">-->
                                    <div @click="detailLessonOpen(item.id,item.type,item.index)">
                                        <div class="item-wave-lesson-inner">
                                            <div class="rating-crown" v-if="item.star">
                                                <img src="/themes/web/assets/images/icon-crown.svg">
                                            </div>
                                            <img src="/themes/web/assets/images/lecture-lesson.svg">
                                            <div class="item-wave-lesson-text">
                                                {{$t('lecture')}} <i class="lisa-icon-checked" v-if="item.complete == 1"></i><i
                                                    class="lisa-icon-checked-disable"
                                                    v-else></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="item-wave-lesson" v-else-if="item.type == 'practice' || item.type == 'practice_ielts'">
                                    <!--<router-link :to="{path: '/lesson/practice/'+item.id}">-->
                                    <div @click="detailLessonOpen(item.id,item.type,item.index)">
                                        <div class="item-wave-lesson-inner">
                                            <div class="crown-default">
                                            <img src="/themes/web/assets/images/icon-crown-disable.svg">
                                            <img src="/themes/web/assets/images/icon-crown-disable.svg">
                                            <img src="/themes/web/assets/images/icon-crown-disable.svg">
                                            </div>
                                            <div class="rating-crown" v-if="item.star">
                                                <img src="/themes/web/assets/images/icon-crown.svg"
                                                     v-for="(i,a) in item.star" v-bind:key="a">
                                            </div>
                                            <img src="/themes/web/assets/images/practice.png">
                                            <div class="item-wave-lesson-text">
                                                {{$t('practice')}} <i class="lisa-icon-checked" v-if="item.complete == 1"></i><i
                                                    class="lisa-icon-checked-disable"
                                                    v-else></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="item-wave-lesson" v-else-if="item.type == 'assignment'">
                                    <div @click="detailLessonOpen(item.id, item.type, item.index)">
                                        <div class="item-wave-lesson-inner">
                                            <div class="rating-crown" v-if="item.star">
                                                <img src="/themes/web/assets/images/icon-crown.svg"
                                                     v-for="(i,a) in item.star" v-bind:key="a">
                                            </div>
                                            <img src="/themes/web/assets/images/assignment.png">
                                            <div class="item-wave-lesson-text">
                                                {{$t('assignments')}} {{ item.index }} <i class="lisa-icon-checked" v-if="item.complete == 1"></i><i
                                                    class="lisa-icon-checked-disable"
                                                    v-else></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="item-wave-lesson" v-else-if="item.type == 'handouts'">
                                    <div @click="detailLessonOpen(item.id, item.type, item.index)">
                                        <div class="item-wave-lesson-inner">
                                            <div class="rating-crown" v-if="item.star">
                                                <img src="/themes/web/assets/images/icon-crown.svg"
                                                     v-for="(i,a) in item.star" v-bind:key="a">
                                            </div>
                                            <img src="/themes/web/assets/images/assignment.png">
                                            <div class="item-wave-lesson-text">
                                                {{$t('handouts')}} <i class="lisa-icon-checked" v-if="item.complete == 1"></i><i
                                                    class="lisa-icon-checked-disable"
                                                    v-else></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>

                        </div>
                        <div class="wave-lesson-bottom">
                            <div style="margin: 0px 20px;color: #1E263C;font-size: 15px;"> {{$t('incomplete')}} <i class="lisa-icon-checked-disable"></i>
                            </div>
                            <div style="margin: 0px 20px;color: #1E263C;font-size: 15px;">{{$t('completed')}} <i class="lisa-icon-checked"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body" v-if="screen == 'vocabulary'">
                    <div class="lesson-action-button vocabulary" @click="showMenuItem"><span>+</span></div>
                    <div class="card-content">
                        <iframe :src="item.content" allow="microphone; camera; autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture; web-share"
                                sandbox="allow-same-origin allow-scripts allow-forms allow-popups **allow-modals** allow-presentation allow-downloads"
                                frameborder="0" allowfullscreen width="100%" height="100%"></iframe>
                    </div>
                </div>
                <div class="" v-if="screen == 'assignment'">
                    <div class="lesson-action-button vocabulary" @click="showMenuItem"><span>+</span></div>
                    <div class="card-content">
                        <iframe :src="item.content" style="border-radius: 4px;"
                                frameborder="0" allowfullscreen width="100%" height="100%"></iframe>
                    </div>
                </div>
                <div class="card-body" v-if="screen == 'lecture'">
                    <div class="lesson-action-button vocabulary" @click="showMenuItem"><span>+</span></div>
                    <!-- <div class="card-header">
                        <h5 class="card-title">
                            <span class="title">{{$t('lecture')}}</span>
                        </h5>
                    </div> -->
                    <div class="card-content">
                        <iframe width="100%" height="100%" :src="item.content" frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen></iframe>
                    </div>
                </div>
                <div class="card-body" v-if="screen == 'practice'">
                    <div class="lesson-action-button vocabulary" @click="showMenuItem"><span>+</span></div>
                    <div class="card-content">
                        <iframe :src="item.content"
                                frameborder="0" allowfullscreen width="100%" height="100%" scrolling="no"></iframe>

                    </div>
                </div>
                <div class="card-body" v-if="screen == 'handouts'">
                    <div class="lesson-action-button vocabulary" @click="showMenuItem"><span>+</span></div>
                    <div class="card-content">
                        <iframe :src="item.content"
                                frameborder="0" allowfullscreen width="100%" height="100%" scrolling="no"></iframe>

                    </div>
                </div>
                <div class="card-body ielts" v-if="screen == 'practice_ielts'||screen == 'listen'||screen == 'read'">
                    <!-- <img @click="showMenuItem" class="lesson-action-button" src="/themes/ito/images/close-program.svg" alt=""> -->
                    <div class="card-content">
                        <iframe :src="item.content"
                                allow="microphone *"
                                frameborder="0" allowfullscreen width="100%" height="100%" scrolling="no"></iframe>

                    </div>
                </div>
            </div>
            <!-- <div class="modal fade reward-popup modal-flex" id="rewardPopup" tabindex="-1" role="dialog" data-backdrop="static"
                 aria-labelledby="rewardPopup" aria-hidden="true" data-keyboard=false> -->
            <!-- <div class="modal fade reward-popup modal-flex" id="rewardPopup" style="z-index: 99999;" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="rewardPopup" aria-hidden="true"> -->
            <div class="modal fade reward-popup modal-flex" id="rewardPopup" style="z-index: 99999;" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="languageModal" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="max-width: 330px;">
                    <div class="modal-content box-shadow-main paymment-status">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" style="width:15px;height:15px" @click="closeModal()"/>
                        <h3 class="popup-title success">{{$t('lisa_web_completed_practice')}}</h3>
                        <div class="list-item-result-popup">
                            <div class="item-result-popup" :class="crown > 0 ? 'active': ''"></div>
                            <div class="item-result-popup" :class="crown > 1 ? 'active': ''"></div>
                            <div class="item-result-popup" :class="crown > 2 ? 'active': ''"></div>
                        </div>
                        <div class="box-result-popup" style="display: flex; align-items: center; justify-content: center;">
                            <div style="text-align:center">
                                <div class="result-txt">{{$t('you_answered_correctly')}}</div>
                                <div class="result-score"><span class="score">{{correct}}</span>/<span class="total">{{total}}</span>
                                    {{$t('questions')}}
                                </div>
                            </div>
                            <!-- <div v-if="gem_reward != 0" class="line-reward"></div>
                            <div v-if="gem_reward != 0" class="gem-reward">+{{gem_reward}}</div>
                            <a v-if="gem_reward != 0" class="lisa-icon-header-gem"></a> -->
                            <div v-if="correct==total" class="line-reward"></div>
                            <div v-if="correct==total" class="gem-reward"><span>+</span> <span>{{gem_reward}}</span> </div>
                            <AppIcon v-if="correct==total" class="m-0" :src="$store.state.gem_icon_url" :size="15" />
                        </div>
                        <button class="next-item-modal" v-if="(next != '' && next != undefined)" @click="nextItem" data-bs-dismiss="modal" aria-label="Close">{{(next != '' && next != undefined)? $t('go_to')+" "+ $t(`${next.type}`) : $t('close')}}</button>
                    </div>
                </div>
            </div>
            <!-- <div id="modalVocabSuccess" class="modal fade modal-flex" tabindex="-1" role="dialog" style="text-align: center; z-index: 99999;"> -->
            <div class="modal fade modal-flex" id="modalVocabSuccess" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="languageModal" aria-hidden="true" style="text-align: center; z-index: 99999;">
                <div class="modal-dialog modal-sm" role="document">
                    <div class="modal-content">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" style="width:15px;height:15px" @click="closeModal()"/>
                        <div class="modal-body" style="text-align: center; padding:0 40px">
                            <h4 class="title">{{ $t('congratulations') }}</h4>

                            <img src="/themes/ito/images/get-rewarded.svg" alt="">
                            <p class="mt-2" style="font-size: 12px;">{{ $t('you_have_completed_your_vocabulary') }}</p>
                            <button class="next-item-modal" v-if="(next != '' && next != undefined)" @click="nextItem" data-bs-dismiss="modal" aria-label="Close">{{(next != '' && next != undefined)? $t('go_to')+" "+ $t(`${next.type}`) : $t('close')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <star-rating-popup v-if="show_survey"
            logo="/themes/web/assets/images/logo.svg"
            :api-url="api_survey"
            :token="token"
            app-code="ipro2"
        />
    </div>
</template>

<script>
    import axios from "axios";
    import {getUnitLessonDetail, getUnitLessonItem, getItemInfo} from "../../models/dashboard";
    import LessonDetailItem from "./LessonDetailItem";
    import { getAssignments } from '../../models/assignment';
    import AppIcon from "@/components/common/AppIcon.vue";

    export default {
        name: "LessonDetail",
        components: {LessonDetailItem, AppIcon},
        title: 'Lesson detail',
        props: [
            'user_info'
        ],
        data() {
            return {
                assignments: [],
                count_submited: 0,
                isLoading: false,
                items: [],
                subject_id: this.$route.params.subject_id,
                unit_id: this.$route.params.unit_id,
                lesson_id: this.$route.params.lesson_id,
                unit_name: '',
                lesson_name: '',
                title_lesson:'',
                item: {},
                screen: 'list',
                correct: 0,
                total: 0,
                crown: 0,
                current_item: 0,
                next: '',
                gem_reward: 30,
                show_next_item: false,
                enable_vocab: JSON.parse(process.env.VUE_APP_ENABLE_VOCAB),
                api_survey: process.env.VUE_APP_API_SURVEY,
                token: localStorage.getItem('access_token') || '',
                show_survey: false
            };
        },

        created() {
            this.getAssignments()
            this.getUnitLessonDetail()
            if (this.item) {
                const f = function (event) {
                    switch (event.data.type) {
                        case 'update_item_info':
                            getItemInfo({
                                id: this.item.id,
                                item_type: this.item.type,
                            });
                    }
                    window.removeEventListener("message", f, false);
                }
                window.addEventListener("message", f);
            }
        },
        mounted() {
            window.addEventListener('message', this.handleMessage)
            window.addEventListener('message', this.handleUpgradeFeature);
        },
        beforeDestroy() {
            window.removeEventListener('message', this.handleMessage)
            window.removeEventListener('message', this.handleUpgradeFeature);
            window.boChatbot?.deleteContext('module')
        },
        computed: {
            user() {
                return this.$store.state.user_info;
            },
        },
        watch: {
            'item': function (newVal, oldVal) {
                if (newVal) {
                    const that = this;
                    let index = this.items.findIndex(x => x.id == newVal.id);
                    that.current_item = index;
                    let array_next = [];
                    for (let i = 0; i < that.items.length; i++) {
                        if (i < that.current_item && that.items[i].complete == 0) {
                            array_next.push(i);
                        }
                        that.next = that.items[array_next[0]];
                        if (i > that.current_item) {
                            if (that.items[i].complete == 0) {
                                that.next = that.items[i];
                                break;
                            } else {
                                if (array_next[0]) {
                                    that.next = that.items[array_next[0]];
                                    break;
                                }
                                else {
                                    that.next = '';
                                }
                            }
                        }
                    }
                }
            }
        },
        methods: {
            async getAssignments() {
                const that = this;
                that.isLoading = true;
                await axios.all([
                    getAssignments({
                        lesson_id: that.lesson_id
                    }),
                ]).then(axios.spread((response) => {
                    that.isLoading = false;
                    if (response.data.code != 0) {
                        return;
                    }
                    that.assignments = response.data.results.assignments || [];
                    that.count_submited = response.data.results.count_submited || 0;
                }));
            },        
            handleFocusOut() {
                var modal = document.getElementById("close-modal");
                modal.style.display = "none";
                this.show_next_item = false;
            },
            async nextItem() {
                $('.card').css({'z-index':'9999'})
                $('.mark-lesson').css({'z-index':'9999'})

                this.show_next_item = false;
                let id = this.next.id;

                var modal = document.getElementById("close-modal");
                modal.style.display = "none";

                const that = this;
                that.isLoading = true;

                await axios.all([
                    getUnitLessonItem(id, localStorage.getItem('lang')),
                ]).then(axios.spread((response) => {
                    that.isLoading = false;
                    console.log("screen", that.screen);

                    if (response.data.code != 0) {
                        return;
                    }

                    that.item = response.data.results.item;
                    that.unit_name = response.data.results.name_unit;
                    that.lesson_name = response.data.results.name_lesson;
                    // that.title_lesson = response.data.results.name.title_lesson
                    // that.lesson_type = response.data.results.item.type;
                    that.screen = response.data.results.item.type;

                }));
            },
            async handleMessage(event) {
                console.log('LCMS: ',event.data.type, this.item);
                if(event.data.action == 'test_close'){
                    this.gotoWave();
                }

                if (this.item) {
                    const that = this;
                    switch (event.data.type) {
                        case 'update_item_info':
                            if(this.item.type != "lecture"){
                                $('.mark-lesson').css({'z-index':'99999'})
                            }
                            await axios.all([
                                getItemInfo({
                                    id: this.item.id,
                                    item_type: this.item.type,
                                }),
                            ]).then(axios.spread((response) => {
                                if(response.data.code != 0){
                                    return;
                                }

                                that.user.dailychallenge_noti = response.data.results.dailychallenge_noti || 0;
                                that.user.count_achieve_unread = response.data.results.count_achieve_unread || 0;

                                ////console.log('xxx',response.data.results.dailychallenge_noti);

                                if(this.item.type == 'practice'){
                                    this.correct = response.data.results.current_result.correct_quest;
                                    this.total = response.data.results.current_result.total_quest;
                                    this.crown = response.data.results.current_result.crown;
                                    $('#rewardPopup').modal('show');
                                }
                                if(this.item.type == 'vocabulary'){
                                    $('#modalVocabSuccess').modal('show');
                                }
                                this.getUnitLessonDetail();
                            })).catch(error => {
                                console.log('sai');
                            });
                            break;

                        case 'update_items':
                            window.boChatbot?.setContext('module', {
                                type: this.screen,
                                data: event.data.data
                            })
                    }
                }
            },
            handleUpgradeFeature(event) {
                if (event.data === 'upgrade_ai_speak') {
                    this.$router.push(`/upgrade-feature?feature_code=speak_ai_attempt`);
                }
                if (event.data === 'upgrade_package') {
                    this.$router.push(`/upgrade-account`);
                }
            },
            showMenuItem() {
                this.show_next_item = true;
                var modal = document.getElementById("close-modal");
                modal.style.display = "block";
            },
            gotoWave() {
                $('.card').css({'z-index':'100'})
                this.$store.commit("setShowEffect", true);
                this.screen = 'list';
                this.show_next_item = false;
                var modal = document.getElementById("close-modal");
                modal.style.display = "none";
                getItemInfo({
                    id: this.item.id,
                    item_type: this.item.type,
                });

                this.show_survey = true
            },

            closeModal(){
                this.screen = 'list';
                this.show_next_item = false;
                var modal = document.getElementById("close-modal");
                modal.style.display = "none";
            },

            async getUnitLessonDetail() {
                const that = this;

                const {subject_id, unit_id, lesson_id} = that.$route.params;

                that.isLoading = true;

                await axios.all([
                    getUnitLessonDetail(subject_id, unit_id, lesson_id),
                ]).then(axios.spread((response) => {
                    that.isLoading = false;

                    if (response.data.code != 0) {
                        return;
                    }
                    that.items = response.data.results.item;
                    that.unit_name = response.data.results.name_unit;
                    that.title_lesson = response.data.results.title_lesson;
                    that.lesson_name = response.data.results.name_lesson;
                    // that.lesson_detail = response.data.results.title_lesson;
                    // that.page_title = that.unit_name + " - " + that.lesson_name + " : " + that.lesson_detail;

                    window.boChatbot?.setContext('unit', response.data.results.title_unit)
                    window.boChatbot?.setContext('lesson', response.data.results.title_lesson)
                }));
            },
            handleGACustomEvent(element, item_id) {
                var params = {
                    'w_user_id': this.user.user_id,
                    'item_id': item_id
                }
                params[element] = this.user.user_id + '|' + item_id
                gtag('event', element, params)
            },
            async detailLessonOpen(id, type, index) {
                // $('#rewardPopup').modal('show');
                const that = this;
                this.$store.commit("setShowEffect", false);
                that.isLoading = true;
               $('.card').css({'z-index':'9999'})

                console.log("detailLessonOpen: ", type);
                var event = ''
                switch (type) {
                    case 'vocabulary':
                        event = 'IP2_W_3000';
                        break;
                    case 'lecture':
                        event = 'IP2_W_3001';
                        break;
                    case 'practice':
                        event = 'IP2_W_3002';
                        break;
                    case 'handouts':
                        event = 'IP2_W_3004';
                        break;
                    default:
                        event = '';
                        break;
                }
                this.handleGACustomEvent(event, id);

                await axios.all([
                    getUnitLessonItem(id, localStorage.getItem('lang'), index),
                ]).then(axios.spread((response) => {
                    that.isLoading = false;

                    if (response.data.code != 0) {
                        return;
                    }
                    console.log(response.data);
                    that.item = response.data.results.item;
                    that.unit_name = response.data.results.name_unit;
                    that.title_lesson = response.data.results.title_lesson;
                    that.lesson_name = response.data.results.name_lesson;
                    // that.lesson_type = response.data.results.item.type;
                    that.screen = response.data.results.item.type;

                    window.boChatbot?.setContext('module', {
                        type: that.screen
                    })
                }));
            }
        }
    }
</script>

<style scoped>
    .card-header{
        height: 52px;
    }
    iframe{
        border-radius: 10px;
    }
    .lesson-action-button span{
        display: block;
        width: 26px;
        height: 26px;
        margin: 13px auto;
        background: #fff;
        text-align: center;
        color: #f04821;
        font-size: 26px;
        line-height: 26px;
        font-weight: 700;
        border-radius: 100%;
        transform: rotate(45deg);
    }
    .card-body{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 10px;
        padding: 20px;
    }
    .lesson-action-button{
        position: absolute;
        top: 20px;
        right: 20px;
        border-radius: 0 7px 0 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 52px;
        height: 52px;
        background: #F04821;
        cursor: pointer;
        z-index: 99999;
    }
    .item-wave-lesson-text .lisa-icon-checked{
        margin-left: 5px;
    }
    .item-wave-lesson-text .lisa-icon-checked-disable{
        margin-left: 5px;
    }
    #page-header .breadcrumb {
        margin-bottom: 0;
    }
    .modal-content{
        padding: 20px 50px 30px;
        color: #000;
    }
    .item-wave-lesson-inner{
        cursor: pointer;
    }
    /*!*.wave-lesson {*!*/
    /*!*position: relative;*!*/
    /*!*height: 550px;*!*/
    /*!*display: flex;*!*/
    /*!*width: 100%;*!*/
    /*!*align-items: center;*!*/
    /*!*}*!*/

    /*.item-wave-lesson {*/
    /*display: inline-block;*/
    /*margin-left: 60px;*/
    /*width: 118px;*/
    /*text-align: center;*/
    /*}*/

    /*.item-wave-lesson:nth-child(2n + 1) .item-wave-lesson-inner {*/
    /*margin-top: -40px;*/
    /*}*/

    /*.item-wave-lesson:nth-child(2n) .item-wave-lesson-inner {*/
    /*margin-top: 140px;*/
    /*}*/

    /*.item-wave-lesson-text {*/
    /*font-size: 16px;*/
    /*font-weight: 700;*/
    /*color: #1E263C;*/
    /*margin-top: 8px;*/
    /*}*/

    /*!*.rating-crown {*!*/
    /*!*width: 80px;*!*/
    /*!*height: 29px;*!*/
    /*!*border: 1px solid #EEF0F7;*!*/
    /*!*box-shadow: 4px 4px 0px 0px #00000012;*!*/
    /*!*margin: auto;*!*/
    /*!*margin-bottom: 5px;*!*/
    /*!*border-radius: 50px;*!*/
    /*!*}*!*/

    /*.wave-lesson-bottom {*/
    /*position: absolute;*/
    /*width: 356px;*/
    /*height: 40px;*/
    /*background: #F5F5F5;*/
    /*border-radius: 16px 16px 0 0;*/
    /*bottom: 0;*/
    /*left: 0;*/
    /*right: 0;*/
    /*margin: auto;*/
    /*display: flex;*/
    /*justify-content: center;*/
    /*align-items: center;*/
    /*}*/

    /*.item-wave-lesson:nth-child(2n + 1) .item-wave-lesson-inner {*/
    /*margin-top: -40px;*/
    /*}*/

    /*.item-wave-lesson:nth-child(2n) .item-wave-lesson-inner {*/
    /*margin-top: 140px;*/
    /*}*/

    /*.item-wave-lesson a {*/
    /*color: #000;*/
    /*}*/

    /*.rating-crown, .item-wave-lesson-inner {*/
    /*position: relative;*/
    /*}*/

    /*.crown-default {*/
    /*display: flex;*/
    /*position: absolute;*/
    /*text-align: center;*/
    /*justify-content: center;*/
    /*width: 57px;*/
    /*top: 0px;*/
    /*left: 0;*/
    /*right: 0;*/
    /*margin: 0 auto;*/
    /*}*/

    /*.crown-default img {*/
    /*width: 19px;*/
    /*height: 18px;*/
    /*}*/

    /*.crown-active-img {*/
    /*z-index: 10;*/
    /*}*/

    /* .lesson-action-button {
        position: absolute;
        top: -156px;
        right: -108px;
        z-index: 1000;
        cursor: pointer
    } */

    .menu-next-item {
        position: fixed;
        width: 200px;
        min-width: fit-content;
        height: 100px;
        right: 25px;
        top: 78px;
        border: 1px solid #dfdfdf;
        border-radius: 10px;
        box-shadow: 4px 4px 0px 0px #00000012;
        background: #fff;
        z-index: 9999;
        padding: 0px 20px;
        animation-name: menu-next-item;
        animation-duration: .2s;
        height: fit-content;
    }

    @keyframes menu-next-item {
        from {
            top: 40px;
            opacity: 0%;
        }

        to {
            top: 57px;
            opacity: 100%;
        }
    }

    .menu-next-item li {
        cursor: pointer;
        list-style: none;
        display: flex;
        height: 50%;
        width: 100%;
        align-items: center;
        justify-content: start;
        font-size: 15px;
        font-weight: 600;
        margin-top: 10px;
        margin-bottom: 10px;
        height: 30px;
    }

    .menu-next-item hr {
        border: none;
        margin: 0;
    }

    .mark-lesson {
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        left: 0;
        right: 0;
        top: 0;
        z-index: 9999;
    }

    .modal-sm {
        max-width: 400px;
    }

    .ito-icon-close {
        position: absolute;
        right: 18px;
    }

    .next-item-modal {
        background: linear-gradient(180deg, #45BCFF 0%, #00A3FF 100%);
        border-radius: 20px;
        box-shadow: 4px 4px 0px 0px #00000012;
        border: none;
        padding: 5px 10px;
        color: #fff;
        margin-top: 10px;
    }

    .box-result-popup {
        padding: 7px 15px;
    }
    .line-reward{
        width: 1px;
        height: 32px;
        background: #C4C4C4;
        margin: 0 5px;
    }
    .gem-reward{
        font-size: 13px;
        font-weight: 600;
        margin-right: 5px;
    }
    .crown-default{
        display: flex;
        text-align: center;
        justify-content: center;
        width: 57px;
        margin: 0 auto;
        margin-top: 0;
        position: absolute;
        left: 0;
        right: 0;
    }
    .crown-default img{
        width: 16px;
        height: 16px;
        margin-top: 1px;
    }
    .rating-crown{
        z-index: 13;
        position: relative;
        padding: 0 15px;
        text-align: left;
        width: 81px;
    }
    #close-modal{
        display: none;
        position: fixed; /* Stay in place */
        z-index: 500; /* Sit on top */
        padding-top: 100px; /* Location of the box */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(0,0,0); /* Fallback color */
        background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
    }
    .close-popup {
        width: 18px;
        height: 18px;
        position: absolute;
        /*background: url(themes/images/close.svg) no-repeat;*/
        background-size: 100%;
        top: 13px;
        right: 13px;
        cursor: pointer;
    }
    #rewardPopup .modal-content{
        padding: 20px 40px 30px;
    }
    #rewardPopup .box-result-popup{
        display: flex;
        align-items: center;
    }
    #rewardPopup .gem-reward{
        align-self: center;
        display: flex;
        align-items: center;
    }
    #rewardPopup .gem-reward span:nth-child(2){
        margin-top: 3px;
    }
    #rewardPopup .gem-reward span:nth-child(1){
        margin-top: 2px;
    }
    .card-body.ielts{
        padding: 0;
    }
    .card-body.practice_game{
        padding: 0;
        margin: 0;
    }
    .card{
        border: none;
    }
</style>